export default __webpack_public_path__ + "static/damixa@1x-948832dcf1bde78535f25d82f0a56708.jpg";